
import React, { Component } from 'react';
import HomeLogin from "./homeLogin";
import HolidaysForm from "./features/holidaysForm";
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import './App.css';
import * as routes from './constants/routes';
import HolidaysConfirmForm from './features/holidaysConfirmForm';
import Holidays from './features/holidayRequestList';
import MyHolidays from './features/myHolidays';
import { Redirect } from 'react-router-dom';
import * as db from './db/db';
import { AppContext } from "./context/applicationContext";
import Holiday from '././features/holidayRequestConfirm';
import AppHeader from './header';
import moment from "moment";
import { createBrowserHistory } from 'history';
import ErrorBoundary from "./error-handler/errorBoundary"
export const history = createBrowserHistory({
    basename: process.env.PUBLIC_URL
});


class NAVIGATION extends Component {
    static contextType = AppContext;
    constructor(props) {
        super(props);

        this.state = { time: Date.now(), redirect: false, path: '', show: false, userData: null};
    }

    componentDidMount() {
        db.idbMethods.getAll(db.userInfo).then((user) => {
            if (user.length > 0) {
                var user = user[0];
                this.callbackData(user);
           
                this.context.setStateCustom('userId', user.userId);
                this.context.setStateCustom('userSite', user.userSite);
                this.context.setStateCustom('token', user.Token);
                this.context.setStateCustom('expireIn', user.Expires);
            } else {
                if (window.location.pathname !== routes.HOME_LOGIN) {
                   this.setState({ redirect: true });
               }
            }
            this.setState({ show: true });
        });
    }
    //if use it, first update
    getNewToken = () => {
        const isMobile = (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
        const now = moment.utc();
        if (localStorage.getItem('expireIn') === undefined || localStorage.getItem('expireIn') === null) {
            this.setState({ redirect: true });
            return false;
        }
        const expireIn = moment(moment(localStorage.getItem('expireIn')).format())
        var new_dateNow = null;
        if (isMobile) {
            new_dateNow = moment(now).add(2, 'days');
        } else {
            new_dateNow = moment(now).add(5, 'minutes');
        }
        if (expireIn.isValid() && new_dateNow.isValid() && expireIn.isAfter(new_dateNow)) {
            return true;
        } else {
            return false;
        }
    }

    callbackData(data) {
        this.setState({ userData: data.userData });
    } 


    render() {
        // if (this.state.redirect && window.location.pathname !== routes.HOME_LOGIN) {
        //     return <Redirect to={routes.HOME_LOGIN} />
        // }
        return (
            <BrowserRouter>
                <div className="container">
                    <div className="row">
                        {this.context.userId != null ? <ErrorBoundary><AppHeader userData={this.state.userData} /></ErrorBoundary> : null}
                        {this.state.show ?
                            <Switch>
                                <Route path={routes.HOLIDAYS_FORM} render={(props) => (<ErrorBoundary><HolidaysForm {...props} /></ErrorBoundary>)} />
                                <Route path={routes.HOLIDAYS_CONFIRM} render={(props) =>(<ErrorBoundary> <HolidaysConfirmForm {...props} /></ErrorBoundary>)} />
                                <Route path={routes.HOLIDAYS} render={(props) =>(<ErrorBoundary> <Holidays {...props} /></ErrorBoundary>)} />
                                <Route path={routes.HOLIDAYS_CONSENT} render={(props) => <HolidaysForConsent {...props} />} />
                                <Route path={routes.HOLIDAY} render={(props) => <Holiday {...props} />} />
                                <Route path={routes.MY_HOLIDAYS} render={(props) =>(<ErrorBoundary> <MyHolidays {...props}  callbackData={(e) => this.callbackData(e)} /></ErrorBoundary>)} />
                                <Route path={routes.HOLIDAY_VIEW} render={(props) =>(<ErrorBoundary> <Holiday {...props} /></ErrorBoundary>)} />
                                <Route path={routes.HOME_LOGIN} render={(props) => (<ErrorBoundary><HomeLogin {...props} /></ErrorBoundary>)} />
                            </Switch> : null}
                    </div>
                    <footer className="footer"><span>© 2022 Lirex.com</span></footer>
                    </div>
            </BrowserRouter>

        );
    }
}

export default NAVIGATION;
